import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { TiVoAppVariantVersion } from "hooks/tivoApps/types";
import { ApiResponse } from "types/api";

export function usePromoteVariant(
  id?: string,
  variantId?: string,
  versionId?: string
) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<TiVoAppVariantVersion>, Error>({
    mutationFn: async () => {
      return dispatch(
        apiThatThrows.promoteTiVoVariantVersion.action({
          params: { id, variantId, versionId },
        })
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["variant", id, variantId] });
    },
  });
}
